import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  divider: {
    background: 'linear-gradient(270deg, rgba(191, 206, 255, 0) 0%, #BFCEFF 100%)',
    height: '2px',
  },
  entireContainer: {
    background: '#fff',
    height: '82vh',
    borderRadius: '12px',
     [theme.breakpoints.down('md')]: {
      height: '100%',
    },
    [theme.breakpoints.up('xxl')]: {
      height: '84vh',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '80.5vh',
    },
  },
  editIcon: {
    color: '#000',
    background: '#fff',
    padding: '5px',
    borderRadius: '12px',
  },
  sepContainer: {
    background: '#F6F8FB',
    borderRadius: '8px',
    marginBottom: '16px',
    padding: '10px 16px',
    '& .MuiGrid-item': {
      padding: '8px',
    },
    marginTop: '30px',
    height: '63vh',
    [theme.breakpoints.up('xxl')]: {
      height: '69vh',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '59vh',
    },
  },
  sepContainer2: {
    background: '#F6F8FB',
    borderRadius: '8px',
    marginBottom: '16px',
    padding: '10px 16px',
    '& .MuiGrid-item': {
      padding: '8px',
    },
  },
  sepContainer1: {
    height: '62vh',
    [theme.breakpoints.up('xxl')]: {
      height: '69vh',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '57vh',
    },
  },
  groupsContainerTitle: {
    fontSize: '15px !important',
    fontWeight: '500 !important',
    textAlign: 'start',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '12.5px !important',
    },
  },

  links: {
    color: '#2C60AA !important',
    fontSize: '12px !important',
    fontWeight: '500 !important',
    lineHeight: '22px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    cursor: 'pointer',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '11.5px !important',
    },
  },
  DiscoverGroupContainer: {
    background: theme.palette.KenColors.kenWhite,
    padding: '20px 20px',
    boxShadow: 'none !important',
    borderRadius: '9px !important',

    [theme.breakpoints.down('md')]: {
      padding: '0px 20px 20px 20px !important',
      marginTop: '50px',
      marginBottom: '-20px'
    },
  },
  DiscoverGroupContainerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '20px',
  },
  rightHeadings: {
    fontSize: '1.125rem',
    fontWeight: "500 !important",
    color: '#373A45',
    [theme.breakpoints.down('md')]: {
      fontSize: '1rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.95rem',
    },
  },
  labelName: {
    fontSize: '0.875rem',
    fontWeight: "500 !important",
    color: '#373A45',
    [theme.breakpoints.down('md')]: {
      fontSize: '0.95rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9rem',
    },
  },
  radioGroup: {
    display: 'flex',
    justifyContent: 'start',
  },
  formControlLabel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '220px',
    [theme.breakpoints.down('sm')]: {
      width: '180px',
    },
  },
  jobPreferenceTitle: {
    textAlign: 'left',
    fontWeight: "500 !important",
    marginTop: '8px',
    marginLeft: '5px',
    fontSize: '1.1rem',
    [theme.breakpoints.down('md')]: {
      fontSize: '1rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.95rem',
    },
  },
  jobPreferCard: {
    borderRadius: 12,
    padding: 15,
    boxShadow: 'none !important',
    height: '84vh',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '80.5vh',
    },
  },
  jobPreferCards: {
    backgroundColor: '#F6F8FB',
    borderRadius: 5,
    padding: 10,
    marginTop: 10,
    boxShadow: 'none !important',
  },
  GroupCard: {
    height: '100%',
    borderRadius: '12px !important',
    textAlign: 'start',
    width: '100%',
    position: 'relative',
    backgroundColor: '#FFFFFF',
    backgroundSize: 'cover !important',
    backgroundPosition: 'center !important',
    display: 'flex',
    flexDirection: 'column',
  },
  cardHeader: {
    color: theme.palette.KenColors.ClientBlack2,
    fontSize: '1.25rem',
    fontWeight: 500,
    textTransform: 'capitalize',
    margin: '0px 30px 0px 4px',
    [theme.breakpoints.down('md')]: {
      fontSize: '1.1rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.95rem',
    },
  },
  cardAvatarGroup: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'start',
  },
  cardActionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '0px',
    margin: '10px auto',
  },
  cardActionContainerTypo: {
    color: theme.palette.KenColors.ClientBlack,
    fontSize: '0.95rem',
    fontWeight: 400,
    marginLeft: '4px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9rem',
    },
  },
  classSixteen: {
    color: theme.palette.KenColors.ClientBlack2,
    fontSize: '1rem',
    fontWeight: 500,
    textTransform: 'capitalize',
    margin: '0px 30px 0px 4px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.95rem',
    },
  },
  personalInfoBox: {
    height: '69vh',
    [theme.breakpoints.up('xxl')]: {
      height: '73vh',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '65vh',
    },
  },
  preferenceBox: {
    height: '62vh',
    [theme.breakpoints.up('xxl')]: {
      height: '67vh',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '56vh',
    },
    '@media (min-width: 1536px) and (max-width: 1636px)': {
      height: '64vh',
    },
  },
  mentorshipBox: {
    height: '60vh',
    [theme.breakpoints.up('xxl')]: {
      height: '67vh',
    },
    [theme.breakpoints.down('md')]: {
      height: 'auto',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '57vh',
    },
    '@media (min-width: 1536px) and (max-width: 1636px)': {
      height: '64vh',
    },
  },
  jobPreferBox: {
    height: '59vh',
    [theme.breakpoints.up('xxl')]: {
      height: '65vh',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '54vh',
    },
    '@media (min-width: 1536px) and (max-width: 1636px)': {
      height: '64vh',
    },
  },
}));
